import React, {useEffect, useState} from 'react';
import '../Body.css';
import './Mannschaftmeldung.css';
import NavbarDisziplin from "../components/NavbarDisziplin";
import ApiService from "../services/ApiService";

function Mannschaftsmeldung(token) {
    const [displayText, setDisplayText] = useState('');
    const [loading, setLoading] = useState(false);

    const [disziplinList, setDisziplinList] = useState([]);
    const [vereinList, setVereinList] = useState(null);
    const [mannschaftList, setMannschaftList] = useState(null);
    const [personList, setPersonList] = useState(null);

    const [selectedDisziplinId, setSelectedDisziplinId] = useState('');
    const [selectedDisziplin, setSelectedDisziplin] = useState(null);
    const [selectedVereinId, setSelectedVereinId] = useState('');
    const [selectedPersonId, setSelectedPersonId] = useState('');
    const [selectedMannschaft, setSelectedMannschaft] = useState('');

    const [isSaveSuccessful, setIsSaveSuccessful] = useState(false);
    const [hasError, setHasError] = useState(false);

    const handleDisziplinClick = (selectedCode) => {
        const disziplin = disziplinList.find(disziplin => disziplin.code === selectedCode);
        setSelectedDisziplin(disziplin);
        setIsSaveSuccessful(false);
        setHasError(false);
        setSelectedDisziplinId(disziplin.id);
        setSelectedVereinId('');
        setSelectedMannschaft('');
        setMannschaftList(null);
        setPersonList(null);

        ApiService.fetchVereinByDisziplin(selectedCode)
            .then(data => {
                setVereinList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));
    };

    const handleVereinChange = (event) => {
        setIsSaveSuccessful(false);
        setHasError(false);
        setDisplayText('');
        setSelectedVereinId('');
        setSelectedMannschaft('');
        const selectedVereinId = event.target.value;
        setSelectedVereinId(selectedVereinId);
        //    setLoading(true);

        ApiService.fetchMannschaftenByDisziplinAndVerein(selectedDisziplinId, selectedVereinId)
            .then(data => {
                setMannschaftList(data);
                //        setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Daten für die rechte Spalte:', error));

        ApiService.fetchPersonsByVerein(token, selectedVereinId, selectedDisziplinId)
            .then(data => {
                setPersonList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Ligen:', error));
    };

    const handleMannschaftChange = (event) => {
        setIsSaveSuccessful(false);
        setHasError(false);
        setDisplayText('');
        const selectedMannschaftId = event.target.value;
        setSelectedMannschaft(selectedMannschaftId);
    };

    const handlePersonChange = (event) => {
        setIsSaveSuccessful(false);
        setHasError(false);
        setDisplayText('');
        const selectedPersonId = event.target.value;
        setSelectedPersonId(selectedPersonId);
    };

    useEffect(() => {
        setLoading(true);
        ApiService.fetchDisziplin()
            .then(data => {
                setDisziplinList(data);
                setLoading(false);
            })
            .catch(error => console.error('Fehler beim Laden der Disziplinen:', error));
    }, []);
    if (loading) {
        return <p>Loading...</p>;
    }

    const handleSave = async () => {
        try {
            const response = await ApiService.createMannschaftsmeldung(
                token,
                selectedPersonId,
                selectedDisziplinId,
                selectedMannschaft);
            if (response) {
                setDisplayText(`Zuordnung erfolgreich gespeichert`);
                // Lade die aktualisierte Liste vom Server
                ApiService.fetchPersonsByVerein(token, selectedVereinId, selectedDisziplinId)
                    .then(data => {
                        setPersonList(data);
                    })
                    .catch(error => console.error('Fehler beim Aktualisieren der Liste:', error));

                setHasError(false);
                setIsSaveSuccessful(true);
            } else {
                setIsSaveSuccessful(false)
                setHasError(true);
                console.error('Fehler beim Speichern der Daten');
                setDisplayText('Fehler beim Speichern der Daten');
            }
        } catch
            (error) {
            setHasError(true);
            console.error('Fehler beim API-Aufruf', error);
            setDisplayText('Fehler beim API-Aufruf');
        }
    };
    const handleDelete = async () => {
        try {
            const response = await ApiService.deleteMannschaftsmeldung(
                token,
                selectedPersonId,
                selectedDisziplinId,
                selectedMannschaft);
            if (response) {
                setDisplayText(`Zuordnung erfolgreich entfernt`);
                // Lade die aktualisierte Liste vom Server
                ApiService.fetchPersonsByVerein(token, selectedVereinId, selectedDisziplinId)
                    .then(data => {
                        setPersonList(data);
                    })
                    .catch(error => console.error('Fehler beim Aktualisieren der Liste:', error));

                setHasError(false);
                setIsSaveSuccessful(true);
            } else {
                setIsSaveSuccessful(false)
                setHasError(true);
                console.error('Fehler beim Entfernen der Zuordnung');
                setDisplayText('Fehler beim Entfernen der Zuordnung');
            }
        } catch
            (error) {
            setHasError(true);
            console.error('Fehler beim API-Aufruf', error);
            setDisplayText('Fehler beim API-Aufruf');
        }
    };

    return (
        <div className="element-content element-background">
            <div className="grid-container-meldung">
                <div className="top-panel-liste">
                    <NavbarDisziplin disziplinList={disziplinList} handleDisziplinClick={handleDisziplinClick} selectedDisziplin={selectedDisziplin}/>
                    {vereinList && (
                        <select value={selectedVereinId} onChange={handleVereinChange}>
                            <option value="" disabled> wähle Verein</option>
                            {vereinList.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.name}
                                </option>
                            ))}
                        </select>
                    )}
                    {mannschaftList && (
                        <select value={selectedMannschaft} onChange={handleMannschaftChange}>
                            <option value="" disabled> wähle Mannschaft</option>
                            {mannschaftList.map((option) => (
                                <option key={option.id} value={option.id}>
                                    id: {option.id} name:{option.name}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
                <div className="right-panel-meldung">
                    {selectedMannschaft && (
                        <div>
                            Wähle den Schützen, der für Mannschaft {selectedMannschaft} bearbeitet werden soll:
                            <div className="selectPerson">
                                <select value={selectedPersonId} onChange={handlePersonChange}>
                                    <option value="" disabled> wähle Schützen</option>
                                    {personList.map((person) => (
                                        <option key={person.personId} value={person.personId}>
                                            {person.vorname} {person.nachname}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <button
                                    className={`saveButton ${isSaveSuccessful ? 'success' : ''} ${hasError ? 'error' : ''}`}
                                    onClick={handleSave}>zu {selectedMannschaft} Hinzufügen
                                </button>
                                <button
                                    className={`saveButton ${isSaveSuccessful ? 'success' : ''} ${hasError ? 'error' : ''}`}
                                    onClick={handleDelete}>von {selectedMannschaft} Entfernen
                                </button>
                            </div>
                            <div className={`hint ${isSaveSuccessful ? 'success' : ''} ${hasError ? 'error' : ''}`}>
                                {displayText}
                            </div>
                        </div>
                    )}
                    {selectedMannschaft && (
                        <ul className="liste">
                            <label>Übersicht aller Schützen des Vereins: </label>
                            <div className="grid-person">
                                <p>Vorname </p>
                                <p>Nachname </p>
                                <p>gemeldet für Mannschaft(en) </p>
                            </div>
                            {personList.map((current, index) => (
                                <li key={current.personId || current.id} className={index % 2 === 0 ? 'even' : 'odd'}>
                                    <div className="grid-person">
                                        <label className="list-row">{current.vorname}</label>
                                        <label className="list-row">{current.nachname}</label>
                                        <label className="list-row">
                                            {current.mannschaften && current.mannschaften.length > 0 
                                                ? current.mannschaften.map(m => `${m.name} (${m.id})`).join(', ')
                                                : (current.mannschaftId ? `${current.mannschaftId}` : '-')}
                                        </label>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Mannschaftsmeldung;
